import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { UserType } from '../../services/user/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-peer-evaluation-grid',
  templateUrl: './peer-evaluation-grid.component.html',
  styleUrls: ['./peer-evaluation-grid.component.css']
})
export class PeerEvaluationGridComponent implements OnInit {

  private _group = null;
  @Input()
  set group(value) {
    if (value) {
      this._group = value;
      this.init()
    }
  }
  get group() {
    return this._group;
  }

  @Input() type: 'rlp' | 'course' = null;

  @Output() save = new EventEmitter();

  @ViewChild('colspan') public colspan: ElementRef;

  public user = null;
  public teacher = null;
  public admin = null;

  constructor(
    private renderer2: Renderer2
  ) { }

  ngOnInit() {
  }

  get groupKey() {
    return this.type === 'course' ? 'course_evaluation' : 'peer_evaluation';
  }

  init() {
    this.user = this.group[this.groupKey].reduce((result, member) => {
      if (member.user.type == UserType.STUDENT || member.user.type == UserType.ALUMNI) {
        result = [
          ...result,
          {
            id: member.user_id,
            name: member.user.name,
            evaluation: member.evaluation
          }
        ];
      }
      return result;
    }, []);
    const teacher = this.group[this.groupKey].find(M => M.user.type == UserType.TEACHER)
    this.teacher = {
      evaluation_id: teacher.id,
      id: teacher.user_id,
      evaluation: teacher.evaluation
    };
    const admin = this.group[this.groupKey].find(M => M.user.type == UserType.ADMIN)
    this.admin = {
      evaluation_id: admin.id,
      id: admin.user_id,
      evaluation: admin.evaluation
    };
    this.user = this.user.map(U => ({
      ...U,
      tpc: this.getTPC(U.id),
      icr: this.getICR(U.id),
      grade: this.getGrade(U.id)
    }));
    // if (this.user.length < 6) {
    //   const count = 6 - this.user.length;
    //   for (let i = 0; i < count; i++) {
    //     this.user.push({
    //       id: -1,
    //       name: '-',
    //       evaluation: null
    //     })
    //   }
    // }
    setTimeout(() => {
      this.renderer2.setAttribute(this.colspan.nativeElement, 'colspan', this.user.length)
    }, 0);
  }

  getUserScore(user1, user2) {
    if (user1 === user2) {
      return 'NA';
    }
    if (user1 === -1 || user2 === -1) {
      return '-';
    }
    const evaluation = this.user.find(U => U.id == user1).evaluation
    if (evaluation) {
      return evaluation.find(U => U.user_id == user2).score;
    } else {
      return 0
    }
  }

  getTeacherScore(user) {
    const evaluation = this.teacher.evaluation
    if (evaluation) {
      return evaluation.find(U => U.user_id == user).score;
    } else {
      return ''
    }
  }

  getAdminScore(user) {
    const evaluation = this.admin.evaluation
    if (evaluation) {
      return evaluation.find(U => U.user_id == user).score;
    } else {
      return 'N/A'
    }
  }

  getTPC(forUser) {
    if (forUser === -1) { return 0; }
    return this.user.reduce((result, member) => {
      if (member.id != forUser) {
        const score = (member.evaluation && member.evaluation.find(M => M.user_id == forUser).score) || 0
        result += Number(score);
      }
      return result;
    }, 0);
  }

  getICR(forUser) {
    return this.getTPC(forUser) / ((this.user.length - 1) * 100);
  }

  getGrade(forUser, icr = null) {
    if (forUser === -1) { return 0; }
    const teachersGrade = (this.teacher.evaluation && this.teacher.evaluation.find(M => M.user_id == forUser).score) || 0
    icr = icr || this.getICR(forUser);
    return (Number(teachersGrade) * 0.75) + (Number(teachersGrade) * icr * 0.25);
  }

  private lockTeacherInput = false;
  private lastTeacherInputValue = '0';
  onTeacherScoreKeydown(event, user) {
    if (this.lockTeacherInput) {
      event.preventDefault();
      return;
    }
    this.lockTeacherInput = true;
    this.lastTeacherInputValue = event.target.value;
  }

  onTeacherScoreKeyup(event, user) {
    const newValue = event.target.value;
    if (newValue !== '' && (!/^[0-9]+(\.[0-9]*)?$/.test(newValue) || Number(newValue) > 10 || Number(newValue) < 1)) {
      event.target.value = this.lastTeacherInputValue;
    }
    this.lockTeacherInput = false;
    if (this.teacher.evaluation) {
      this.teacher.evaluation = this.teacher.evaluation.map(E => {
        if (E.user_id == user.id) {
          return { user_id: user.id, score: Number(event.target.value) }
        }
        return E;
      })
    } else {
      this.teacher.evaluation = this.user.reduce((result, U) => {
        if (U.id == user.id) {
          result.push({ user_id: user.id, score: Number(event.target.value) });
        } else if (U.id !== -1) {
          result.push({ user_id: U.id, score: '' });
        }
        return result;
      }, []);
    }
    user.grade = this.getGrade(user.id, user.icr)
  }

  private lockAdminInput = false;
  private lastAdminInputValue = '0';
  onAdminScoreKeydown(event, user) {
    if (this.lockAdminInput) {
      event.preventDefault();
      return;
    }
    this.lockAdminInput = true;
    this.lastAdminInputValue = event.target.value;
  }

  onAdminScoreKeyup(event, user) {
    const newValue = event.target.value;
    if (newValue !== '' && (!/^[0-9]+(\.[0-9]*)?$/.test(newValue) || Number(newValue) > 10 || Number(newValue) < 1)) {
      event.target.value = this.lastAdminInputValue;
    }
    this.lockAdminInput = false;
    if (this.admin.evaluation) {
      this.admin.evaluation = this.admin.evaluation.map(E => {
        if (E.user_id == user.id) {
          return { user_id: user.id, score: Number(event.target.value) }
        }
        return E;
      })
    } else {
      this.admin.evaluation = this.user.reduce((result, U) => {
        if (U.id == user.id) {
          result.push({ user_id: user.id, score: Number(event.target.value) });
        } else if (U.id !== -1) {
          result.push({ user_id: U.id, score: '' });
        }
        return result;
      }, []);
    }
    user.grade = this.getGrade(user.id, user.icr)
  }

  onSaveClick() {
    if (!this.teacher.evaluation || this.teacher.evaluation.find(E => !E.score)) {
      swal('Warning', 'Fill all the fields under Jury\'s grade.', 'warning');
      return;
    }
    this.save.emit(this.teacher);
  }

  getName(name) {
    name = name.replace(/[\u00A0]/g, ' ');
    const names = name.trim().replace('&nbsp;', ' ').split(' ');
    return names.length > 1 ? names[0] + '<br>' + names[names.length - 1] : names[0] + '<br>&nbsp;';
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/peer-evaluation-grid/peer-evaluation-grid.component.ts